// dependencies
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

// get our store
import createStore from "./Store";

import App from "./App";
// import registerServiceWorker from './registerServiceWorker';

// create our redux instance
const store = createStore();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
	<Provider store={store}>
		<App />
	</Provider>
);

// registerServiceWorker();
